import {
	Box,
	Button,
	Card,
	CardBody,
	CardFooter,
	CardHeader,
	Flex,
	FormControl,
	FormLabel,
	HStack,
	Heading,
	Input,
	Text,
	Tooltip,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { jwtDecode } from "jwt-decode";

const InvestmentCard = (props) => {
	const { investment, setInvestment, investmentError, setInvestmentError } =
		props;
	const [role, setRole] = useState();
	const {
		handleSubmit,
		register,
		formState: { errors },
	} = useForm();

	const onSubmit = (data) => {
		if (
			investment === undefined ||
			investment === null ||
			investment === "" ||
			investment <= 0
		) {
			setInvestmentError("Increment amount is required");
		} else {
			setInvestmentError();
			props.handleClickInterest(investment);
		}
	};
	useEffect(() => {
		let tempToken = sessionStorage.getItem("token");
		const decodedJWT = jwtDecode(tempToken);
		if (decodedJWT.role === "User") {
			setRole("User");
		} else {
			setRole("Admin");
		}
	}, []);

	return (
		<Card
			color="#1C3E64"
			fontSize="14.4px"
			position="sticky"
			top="20px"
			borderRadius="10px"
			border="1px solid #F0F0F0"
		>
			<CardHeader textAlign="center" pt="30px">
				<Heading fontSize="24px" fontWeight="400">
					Investment Opportunity
				</Heading>
			</CardHeader>
			<CardBody p="0">
				<HStack p="30px" bgColor="#F0F3FB" justify="space-between">
					<Text>Minimum investment Allocation</Text>
					<Text fontWeight="600">${props.minimumInvestment}</Text>
				</HStack>
				<form onSubmit={handleSubmit(onSubmit)}>
					<FormControl p="20px 25px 15px 25px">
						<FormLabel>Type a number of increments you want</FormLabel>
						<Flex
							w={{ base: "100%", xl: "92%" }}
							align="center"
							mt="36px"
							mb="12px"
							direction={{ base: "column", xl: "row" }}
							gap="24px"
						>
							<Box>
								<Input
									border="1px solid #d2d8dd"
									borderRadius="3px"
									type="number"
									value={investment}
									onChange={(e) => {
										console.log("e.target.value: ", e.target.value);
										if (
											e.target.value <= parseInt(props.totalShares) &&
											e.target.value >= 0
										) {
											setInvestment(e.target.value);
										}
									}}
									name="investmentAmount"
								/>
								{investmentError && <Text color="red">{investmentError}</Text>}
							</Box>
							<Text>
								Available number of Increments: <b>{props.totalShares}</b>
							</Text>
						</Flex>
						<Text textAlign="center">Your Investment</Text>
						<Text my="24px" textAlign="center" fontSize="25px" fontWeight="600">
							${props.minimumInvestment * investment}
						</Text>
						<Text textAlign="center">
							Share of total equity:{" "}
							{Math.round((investment / props.totalShares) * 100)}%
						</Text>
						<Tooltip label={role == "Admin" ? "Please Login As User" : ""}>
							<Button
								isDisabled={role == "Admin" ? true : false}
								border="1px solid #002B5B "
								type="submit"
								_hover={{ color: "#002B5B", bgColor: "white" }}
								w="100%"
								fontFamily="Raleway"
								bgColor="#002B5B"
								color="white"
								fontSize={{ base: "13px", md: "16px" }}
								p="12px 26px"
							>
								Express Interest
							</Button>
						</Tooltip>
					</FormControl>
				</form>
			</CardBody>
			<CardFooter flexDirection="column" p="30px 0">
				<Text textAlign="center">If you need help, email us at</Text>
				<Text textAlign="center">support@redswan.io</Text>
			</CardFooter>
		</Card>
	);
};

export default InvestmentCard;
